import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { openModal, OpenModal } from 'src/actions/modal';
import RegisterContainer from 'src/modules/modals/register/Register.container';
import HowToInvestComponent from 'src/modules/how-to-invest/HowToInvest.component';

interface StateProps {
  isLogged?: boolean;
}

interface DispatchProps {
  openModal: (content: JSX.Element) => void;
}

interface Props extends StateProps, DispatchProps {
}

class HowToInvestContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    return (
      <HowToInvestComponent
        register={() => this.register()}
        isLogged={this.props.isLogged}
      />
    );
  }

  private register(): void {
    this.props.openModal(
      <RegisterContainer/>
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    openModal: (content: JSX.Element): OpenModal => {
      return dispatch(openModal(content));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  isLogged: state.authentication.isLogged,
});

export default connect(mapStateToProps, mapDispatchToProps)(HowToInvestContainer);


// WEBPACK FOOTER //
// ./src/modules/how-to-invest/HowToInvest.container.tsx